import instance from '../axios';

export const currentRoute = () => {
  return instance.get('/route/currentRoute');
};

export const createRoute = (newRoute) => {
  return instance.post('/route', newRoute);
};

export const getOpenRoutes = () => {
  const routeData = {
    params: {
      status: 'OPEN',
    },
  };
  return instance.get('/route', routeData);
}

export const getComprobation = (idRoute) => {
  return instance.get('/route/comprobation', { params: { route_id: idRoute } });
} 

export const createComprobation = (idRoute) => {
  return instance.post('/route/comprobation', { route_id: idRoute });
}

export const closeRoute = (idRoute) => {
  return instance.put(`/route/${idRoute}/close`);
}

export const openRoute = (idRoute) => {
  return instance.put(`/route/${idRoute}/open`);
}

export const getRoute = (idRoute) => {
  return instance.get(`/route/${idRoute}`);
}

export const getMetalLoadForRouteInBag = (route, bag) => {
  if(route && bag) {
    return instance.get(`/batch/info?route=${route.id}&bag=${bag.id}`);
  } else {
    return instance.get(`/batch/info?bag=${bag.id}`);
  }
}